import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import {
  PageBar,
  SSPCommonButton,
  SSPCommonVideo,
  SSPCommonTable,
} from "../../CommonComponents";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import { Download } from "@mui/icons-material";
import AWS from "aws-sdk";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Modal,
  IconButton,
  Link,
} from "@mui/material";
import clsx from "clsx";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import styled from "styled-components";
import * as FileSaver from "file-saver";
import { post } from "../../services";
import Cookies from "js-cookie";
import { isDevelopment } from "../../Hooks/constants";

const DNC_Registry_Update = () => {
  const id = Cookies.get("ssp_id");

  // Dynamic Base URL based on Environment Variables
  const base = isDevelopment
    ? `${process.env.REACT_APP_MDM_DEV || process.env.REACT_APP_SSP_MDM_DEV}`
    : `${process.env.REACT_APP_MDM_PROD || process.env.REACT_APP_SSP_MDM_PROD}`;
  const boxSX = {
    textDecoration: "none",
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
      color: "darkblue",
    },
  };

  // const { id,token } = useParams();s
  const [modalOpener, setmodalOpener] = useState(false);
  const [message, setmessage] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [vendorName, setVendorName] = useState("");
  const [rows, setRows] = useState([]);
  const [originalRowsData, setOriginalRowsData] = useState([]);
  const [saveLoading, setSaveLoading] = useState(false);

  const rowFetch = async () => {
    setmessage("Fetching Data");
    let response = await post(
      base,
      {
        action: "upload_details",
        module: "mdm_dnc_registry",
        user_id: parseInt(id),
        rawPath: "/dnc_update",
      },
      true,
      false
    );
    if (response?.data?.length) {
      const rowsData = response?.data.map((row, index) => ({
        ...row,
        id: index + 1,
      }));
      setOriginalRowsData(rowsData);
      setRows(rowsData);
    } else {
      setmessage("No Rows");
      setmodalOpener(true);
    }
  };
  useEffect(() => {
    rowFetch();
  }, []);

  const handleFileUpload = async () => {
    try {
      setLoading(true);
      const timestamp = new Date()
        .toISOString()
        .replace(/[-:.]/g, "")
        .slice(0, 15); // YYYYMMDDTHHMMSS
      const folderName = "DNC_Registry";
      const filenameWithTimestamp = `${folderName}/${selectedFile.name
        .split(".")
        .slice(0, -1)
        .join(".")}_${timestamp}.${selectedFile.name.split(".").pop()}`;
      // Step 1: Get the presigned URL
      const presignedUrlResponse = await post(
        base,
        {
          file_name: filenameWithTimestamp?.replace(/[()]/g, ""),
          rawPath: "/get_pre_url",
        },
        true,
        false
      );
      const presignedUrl = presignedUrlResponse?.body;
      if (!presignedUrl) {
        return;
      }

      // Step 2: Upload the file to the presigned URL
      const fileUploaded = await uploadFileWithPresignedUrl(
        selectedFile,
        presignedUrl
      );
      if (fileUploaded) {
        setSelectedFile(null);
        const approvalPayload = {
          user_id: String(id),
          file_name: filenameWithTimestamp?.replace(/[()]/g, ""),
          action: "upload_excel",
          rawPath: "/dnc_update",
        };

        // Step 3: Send the payload to /save_po_stagging_data
        const approvalResponse = await post(
          base,
          JSON.stringify(approvalPayload),
          true,
          false
        );
        if (approvalResponse?.status === "Success") {
          setmessage("File uploaded successfully!");
        } else {
          setmessage(
            approvalResponse?.body?.message ||
            "Unknown error occurred during upload."
          );
        }
        setSelectedFile(null);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        setmodalOpener(true);
      } else {
        setmessage("File upload failed");
        setmodalOpener(true);
      }
    } catch (error) {
      setmessage(error.message);
      setmodalOpener(true);
    } finally {
      setLoading(false);
      setSelectedFile(null);
    }
  };

  const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
    try {
      const fileUploadData = new FormData();
      Object.keys(generatedUrl.fields).forEach((key) => {
        fileUploadData.append(key, generatedUrl.fields[key]);
      });
      fileUploadData.append("file", filetoUpload);
      const fileUploaded = await uploadFile(generatedUrl.url, fileUploadData);

      if (fileUploaded) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      throw error;
    }
  };

  const uploadFile = async (url, formData) => {
    try {
      const response = await axios.post(url, formData);

      if (response.status === 204) {
        return true;
      }

      if (response.status >= 200 && response.status < 300) {
        return true;
      } else {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };

  const HoverCell = ({ value }) => {
    return (
      <Tooltip title={value}>
        <div style={{ whiteSpace: "normal", textAlign: "start" }}>{value}</div>
      </Tooltip>
    );
  };


  const downloadProgressFile = async (logId) => {
    let response = await post(
      base,
      {
        action: "process_log",
        log_id: String(logId),
        rawPath: "/dnc_update",
      },
      true,
      false
    );

    if (response.status === "error") {
      setmessage(response?.body?.message);
      setmodalOpener(true);
      return;
    }


    let data1 = response?.body?.data?.map((obj) => ({
      message: obj.message,
      log_id: obj.log_id,
      customer_number: obj.customer_number,
      status: obj.status,
    }));
    DownloadExcelSheet(data1, "DNC_Registry");
  };
  const ExcelJS = require("exceljs");
  const DownloadExcelSheet = async (response, fileName) => {
    if (response !== null) {
      let data = response;
      const workbook = new ExcelJS.Workbook();
      const headers = Object.keys(data[0]);
      const worksheet = workbook.addWorksheet("data");
      const firstRow = worksheet.getRow(1);
      for (let i = 1; i <= headers.length; i++) {
        const cell = firstRow.getCell(i);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFA500" },
        };
      }
      worksheet.columns = headers.map((header) => ({ header, key: header }));
      data.forEach((dataRow) => {
        worksheet.addRow(dataRow);
      });
      worksheet.columns.forEach((column) => {
        column.width = 25;
      });
      workbook.xlsx.writeBuffer().then((buffer) => {
        const data = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(data, fileName + ".xlsx");
      });
    } else {
      setmessage("No data provided to download the file");
      setmodalOpener(true);
    }
  };
  const handleDownloadSampleFile = async () => {
    let response = await post(
      base,
      JSON.stringify({
        action: "download_template",
        file_name: "samplefiles/DNC_Sample.xlsx",
        rawPath: "/dnc_update",
      }),
      true,
      false
    );
    window.open(response?.body.url);
  };
  const handleDownloadCurrentDNC = async () => {
    try {
      let response = await post(
        base,
        JSON.stringify({
          action: "current_dnc_registry",
          rawPath: "/dnc_update",
        }),
        true,
        false
      );

      if (response?.status === "error") {
        setmessage(response?.body.message);
        setmodalOpener(true);
        return;
      }

      let data1 = response?.data.map((obj) => ({
        customer_number: obj.customer_number,
      }));
      DownloadExcelSheet(data1, "Current_DNC");
    } catch (error) {
      console.error("Error during download:", error);
      setmessage(
        "An error occurred while downloading the file. Please try again."
      );
      setmodalOpener(true);
    }
  };

  const columns = [
    { field: "id", headerName: "Sr.no", flex: 0.5 },
    {
      field: "file_name",
      headerName: "Files Name",
      flex: 2,
      wrapText: true,
      align: "left",
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "updated_at",
      headerName: "Date",
      flex: 1,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      align: "center",
      headerAlign: "center",
      cellClassName: (params) => {
        if (params.value == null) {
          return "";
        }

        return clsx("super-app", {
          positive: params.value === "Success",
          negative: params.value === "Error",
          partial: params.value === "Partial Success",
        });
      },
    },
    {
      field: "count",
      align: "center",
      headerAlign: "center",
      headerName: (
        <div style={{ fontSize: "14px", lineHeight: "1.2" }}>
          <div>No of records </div>
          <div>processed</div>
        </div>
      ),
      flex: 1,
      wrapText: true,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "current_status",
      headerName: "Progress",
      // headerAlign: 'center',
      // align: "center",
      flex: 1,
      wrapText: true,
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
      cellClassName: (params) => {
        if (params.value == null) {
          return "";
        }

        return clsx("super-app", {
          progressdata: params.value === "Master Updated",
          progressdatafail:
            params.value === "Error" || params.value === "Invalid File/Data",
          progressdatapartial: params.value === "Partially Master Updated",
        });
      },
    },
    {
      field: "log_id",
      headerName: "Process Logs",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      renderCell: (params) => (
        <IconButton
          aria-label="Download"
          onClick={() => downloadProgressFile(params.row.log_id)}
        >
          <Download color="primary" />
        </IconButton>
      ),
    },
  ];

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#EEF2F7",
        }}
      >
        {/* Page Bar */}
        <PageBar
          text="Customer Data Management -> Customer DNC Registry "
          vendorId={id}
          vendorName={vendorName}
        />

        <Card
          sx={{
            backgroundColor: "#EEF2F7",
            padding: "1.3rem",
          }}
        >
          <CardHeader
            p={2}
            sx={{
              backgroundColor: "#F8F8F9",
              fontWeight: "700",
              borderTopRightRadius: "5px",
              borderTopLeftRadius: "5px",
            }}
            title={" Upload excel containing mobile numbers"}
            titleTypographyProps={{
              sx: {
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "16px",
                color: "#0160F1",
              },
            }}
          />
          <Divider />
          <CardContent
            sx={{
              backgroundColor: "#FFFFFF",
              borderBottomRightRadius: "5px",
              borderBottomLeftRadius: "5px",
              fontSize: 15,
              // marginBottom: -5
            }}
          >
            <Grid container Spacing={2}>
              <Box
                p={2}
                sx={{
                  display: { lg: "flex", md: "flex" },
                  gap: "1rem",
                }}
              >
                <Box
                  p={1}
                  sx={{
                    border: "1px solid lightgrey",
                    borderRadius: "5px",
                    marginBottom: { sm: "1rem" },
                  }}
                >
                  <input
                    type="file"
                    // accept=".zip"
                    multiple={false}
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                  />
                </Box>
              </Box>

              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                lg={3}
                sx={{ marginTop: 2, marginBottom: 1 }}
              >
                <SSPCommonButton
                  btnText={"SAVE DATA"}
                  btnFunction={handleFileUpload}
                  loading={loading}
                />
              </Grid>
            </Grid>
            <Grid container rowSpacing={1}>
              <Box
                p={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "16px",
                  marginRight: "1rem",
                }}
              >
                <Link
                  component={"button"}
                  color={"#0160F1"}
                  sx={boxSX}
                  onClick={handleDownloadSampleFile}
                >
                  {"Download Sample File"}
                </Link>
              </Box>
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  height: "1.2rem",
                  marginTop: 1,
                  backgroundColor: "#c0c0c0",
                  width: 2,
                }}
              />
              <Box
                p={1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: "500",
                  lineHeight: "16px",
                  marginLeft: "1rem",
                }}
              >
                <Link
                  component={"button"}
                  color={"#0160F1"}
                  sx={boxSX}
                  onClick={handleDownloadCurrentDNC}
                >
                  {"Download Current DNC Registry"}
                </Link>
              </Box>
            </Grid>
          </CardContent>
        </Card>

        {/* Table  */}
        <Card
          sx={{
            backgroundColor: "#EEF2F7",
            padding: "1.3rem",
          }}
        >
          <CardHeader
            p={2}
            sx={{
              backgroundColor: "#F8F8F9",
              fontWeight: "700",
              borderTopRightRadius: "5px",
              borderTopLeftRadius: "5px",
            }}
            title={"Uploaded Files "}
            titleTypographyProps={{
              sx: {
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "16px",
                color: "#0160F1",
              },
            }}
            action={
              <>
                <Button onClick={() => window.location.reload()}>
                  Refresh Page
                </Button>
              </>
            }
          />
          <Divider />
          <CardContent
            sx={{
              backgroundColor: "#FFFFFF",
              borderBottomRightRadius: "5px",
              borderBottomLeftRadius: "5px",
            }}
          >
            <Box
              sx={{
                height: 700,
                width: "100%",
                "& .super-app.positive": {
                  color: "rgb(4,171,105)",

                  fontWeight: "600",
                },
                "& .super-app.negative": {
                  color: "rgb(234,39,21)",

                  fontWeight: "600",
                },
                "& .super-app.partial": {
                  color: "rgb(244,161,0)",

                  fontWeight: "600",
                },
                "& .super-app.progressdata": {
                  color: "rgb(4,171,105)",

                  fontWeight: "600",
                },
                "& .super-app.progressdatafail": {
                  color: "rgb(234,39,21)",

                  fontWeight: "600",
                },
                "& .super-app.progressdatapartial": {
                  color: "rgb(244,161,0)",

                  fontWeight: "600",
                },

                "& .super-app.processing": {
                  color: "rgb(104,112,122)",

                  fontWeight: "600",
                },
                "& .super-app.pending": {
                  color: "rgb(3,95,240)",

                  fontWeight: "600",
                },
              }}
            >
              <DataGrid
                // disableColumnMenu={true}
                rowHeight={80}
                showCellRightBorder={true}
                sx={{
                  ".MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "bold !important",
                  },
                  overflowX: "scroll",
                }}
                rows={rows}
                columns={columns}
                headerClassName="header-center"
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                rowsPerPageOptions={[10]}
                pageSize={10}
                getRowId={(row) => row.id}
                components={{
                  Toolbar: GridToolbar,
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />
            </Box>
          </CardContent>
        </Card>
        {/* Video  */}
        {/* <SSPCommonVideo
                    headerText={"Demo Video"}
                    videoUrl={"https://www.youtube.com/embed/zJhH4Rgrto8?si=vRLlLSAlY0OEh4zc"}
                /> */}
        {modalOpener && (
          <SSPCommonModal
            open={modalOpener}
            handleOpenClose={setmodalOpener}
            message={message}
          />
        )}
      </Box>
    </>
  );
};

export default DNC_Registry_Update;
